import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import WordSearch from "@/pages/WordSearch";
import VerseLookup from "@/pages/VerseLookup";
import Dictionary from "@/pages/Dictionary";
import Topical from "@/pages/Topical";
import Studies from "@/pages/Studies";
import Shared from "@/pages/Shared";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/word" element={<WordSearch />} />
            <Route path="/verse" element={<VerseLookup />} />
            <Route path="/dictionary" element={<Dictionary />} />
            <Route path="/topical" element={<Topical />} />
            <Route path="/studies" element={<Studies />} />
            <Route path="/share/:token" element={<Shared />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
